import React, { useEffect } from "react";
import { Row, Col, Image, Button, Form } from "react-bootstrap";
import { MagnifierIcon, SaveIcon } from "../../assets/svg/svg-icons";
import { useDispatch, useSelector } from "react-redux";
import plastic1 from "../../assets/images/plastic-1.png";
import "react-image-gallery/styles/css/image-gallery.css";
import "./account.css";
import { getApi } from "../../actions/structure.action";
import isEmpty from "../../utils/is-Empty";
import { Link } from "react-router-dom";
import moment from "moment";

const EnquiryList = () => {
  const dispatch = useDispatch();

  const { enquiry } = useSelector((state) => {
    return state;
  });

  useEffect(() => {
    getApi("getEnquiry", dispatch);
  }, []);

  const enquiryItem = (item, index) => {
    // console.log("ENQUIRY ITEM: ", item);
    const todayDate = moment().tz("Asia/Kolkata").format("YYYY-MM-DD");
    const enquiryDate = item?.enquiryCreatedAt
      ? moment(item?.enquiryCreatedAt).tz("Asia/Kolkata").format("YYYY-MM-DD")
      : null;
    const highlight = enquiryDate === todayDate;

    let otherDetails = JSON.parse(item?.other_details);
    let enquirySize =
      otherDetails?.variant >= 1000
        ? otherDetails?.variant / 1000 + " L"
        : otherDetails?.variant + " ml";
    return (
      <Link
        key={`${index}_Order_${item?.enquiry_pk_id}`}
        className="order-link"
        to={`/enquiry/${item?.enquiry_id}`}
      >
        <Row
          className={`order-summery-card-my-account m-0 mb-4`}
          style={{ backgroundColor: highlight ? "#e6ffe6" : "#ffffff" }}
        >
          <Col xs={2} sm={2} md={2} className="image-col">
            <Image src={item?.image_url || plastic1} alt={item?.brand_name} />
          </Col>
          <Col xs={10} sm={10} md={10}>
            <Row className="m-0 p-0">
              <Col xs={12} sm={12} md={12} className="m-0 p-0 text-start summary-card-title">
                <span className="m-0 p-0 small muted">{`# ${item?.enquiry_id}`}</span>
              </Col>
              <Col xs={12} sm={12} md={12} className="m-0 p-0 mt-2 text-start">
                <div className="summary-card-title">
                  {!isEmpty(item?.offer_price) ? (
                    <span>
                      {`${item?.brand_name} - ${item?.product_name} | ₹ ${item?.offer_price}/case`}{" "}
                      <s>{`₹ ${item?.price}/case`}</s>{" "}
                    </span>
                  ) : (
                    <span>{`${item?.brand_name} - ${item?.product_name} | ₹ ${item?.price}/case`}</span>
                  )}
                </div>
                <hr className="mx-0 p-0 mb-2 mt-1" style={{ width: "100%" }} />
                <div className="summary-card-details">
                  <Row className="">
                    <Col xs={2} sm={2} md={2} className="my-acccount-summary-card-item">
                      <p className="small muted">{"Size"}</p>
                      <h6 className="small">{`${enquirySize}`}</h6>
                    </Col>
                    <Col xs={2} sm={2} md={2} className="my-acccount-summary-card-item">
                      <p className="small muted">{"MOQ"}</p>
                      <h6 className="small">{`${item?.moqData?.displayName || item?.moq} Case`}</h6>
                    </Col>
                    <Col xs={4} sm={2} md={2} className="my-acccount-summary-card-item">
                      <p className="small muted">{"Amount"}</p>
                      <h6 className="small">
                        {"₹  "}
                        {!isEmpty(item?.offer_price)
                          ? parseInt(item?.moq) * parseInt(item?.offer_price)
                          : parseInt(item?.moq) * parseInt(item?.price)}
                      </h6>
                    </Col>
                    <Col xs={4} sm={6} md={6} className="text-end mt-3">
                      <Button
                        variant="outline-secondary"
                        size="sm"
                        className="text-uppercase"
                        disabled
                        style={{ fontSize: "12px" }}
                      >
                        {`${item?.enquiry_status}`}
                      </Button>
                      {/* <Button className="text-uppercase btn">{`${item?.enquiry_status}`}</Button> */}
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Link>
    );
  };

  return (
    <>
      <div className="my-order-headingbox">
        <h4 className="text-uppercase m-0">{"my enquiries"}</h4>
        <div className="search-and-dropdown-box">
          <MagnifierIcon />
          <Form.Select aria-label="Default select example">
            <option value="1">{"Last 3 month"}</option>
            <option value="2">{"Last 6 month"}</option>
            <option value="3">{"Last 9 month"}</option>
          </Form.Select>
        </div>
      </div>
      <hr />
      <div
        style={{
          maxHeight: "36rem",
          overflowY: "auto",
        }}
      >
        {!isEmpty(enquiry?.data?.enquiryDetails) &&
          enquiry?.data?.enquiryDetails?.length > 0 &&
          enquiry?.data?.enquiryDetails?.map((item, index) => {
            return enquiryItem(item, index);
          })}

        {isEmpty(enquiry?.data?.enquiryDetails) && <p>{"No enquiries placed"}</p>}
      </div>
    </>
  );
};

export default EnquiryList;
